// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_1b4","cls2":"EvaluationPage-cls2_mHA EvaluationPage-cls1_1b4"};